export default __webpack_public_path__ + "static/home-mobile-3-cf50341f280e5e68ed1c755b8e66c5db.png";